<template>
  <div class="container-fluid">
    <card-list-home></card-list-home>
    
    <div class="row">
      <div class="col-md-6 py-2">
        <wdg-revenues-per-hour />
      </div>
      <div class="col-md-6 py-2">
        <wdg-revenues-count-itens />
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 py-2">
        <revenues
          :height="300"
          :p-show-period="true"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 py-2">
        <home-sales-payment />
      </div>
      <div class="col-md-6 py-2">
        <products-most-saled />
      </div>
    </div>

    <card-list-bills-to-pay />
    <div class="row">
      <div class="col-md-6 py-2">
        <vw-bills-to-pay
          :p-show-period="true" 
          title="Contas pagas no(s) ultimo(s)"
          :type="0"
          :height="300" 
        />
      </div>

      <div class="col-md-6 py-2">
        <vw-bills-to-pay
          :p-show-period="true" 
          title="Contas a pagar no(s) próximos(s)"
          :type="1"
          :height="300" 
        />
      </div>
    </div>

    <card-list-bills-to-receive />
    <div class="row">
      <div class="col-md-6 py-2">
        <div class="card">
          <vw-bills-to-receive
            :p-show-period="true" 
            title="Contas recebidas no(s) ultimo(s)"
            :type="0"
            :height="300" 
          />
        </div> 
      </div>
      <div class="col-md-6 py-2">
        <vw-bills-to-receive
          :p-show-period="true" 
          title="Contas a receber no(s) próximos(s)"
          :type="1"
          :height="300" 
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 py-2">
        <default-risk 
          :type="1" 
          title="Contas a receber"
          :is-clock="false"
          color="#17a2b8"
        />
      </div>
      <div class="col-md-6 py-2">
        <default-risk 
          :type="0" 
          title="Contas a pagar"
          :is-clock="true"
          color="#17a2b8"
        />
      </div>
    </div>
  </div>
</template>

<script>
import cardListHome from '@/components/cardlists/dashHome.vue'
import CardListBillsToReceive from '@/components/cardlists/CardListBillsToReceive.vue'
import CardListBillsToPay from '@/components/cardlists/CardListBillsToPay.vue'
import sales from '@/components/graphs/salesPayment.vue'
import newSales from '@/components/vwHome/newSales.vue'
import cashRegister from '@/components/vwHome/cashRegister.vue'
import clientes from '@/components/vwHome/clientes.vue'
import homeSales from '@/components/homeSales.vue'
import vwBillsToReceive from '@/components/vwHome/vwBillsToReceive.vue'
import vwBillsToPay from '@/components/vwHome/vwBillsToPay.vue'
import revenues from '@/components/vwHome/vwRevenuesPerPeriod.vue'
import homeSalesPayment from '@/components/homeSalesPayment.vue'
import productsMostSaled from '@/components/grids/productsMostSaled.vue'
import defaultRisk from '@/components/graphs/defaultRisk.vue'
import wdgRevenuesPerHour from '@/components/vwHome/vwRevenuesPerHour.vue'
import wdgRevenuesCountItens from '@/components/vwHome/vwRevenuesCountItens.vue'

export default {
  name: 'vwHome',
  components: {
    cardListHome,
    CardListBillsToReceive,
    CardListBillsToPay,
    sales,
    newSales,
    cashRegister,
    clientes,
    homeSales,
    vwBillsToReceive,
    vwBillsToPay,
    revenues,
    homeSalesPayment,
    productsMostSaled,
    defaultRisk,
    wdgRevenuesPerHour,
    wdgRevenuesCountItens
  }
}
</script>
<style scoped>
  .col-md-6,
  .col-md-4,
  .col-md-8{
    margin-bottom: 10px;
  }
</style>